export function getModuleTocId(projectId: number, moduleId: number | undefined): string | undefined {
  return moduleId !== undefined ? `toc_${projectId}_${moduleId}` : undefined;
}
